import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const Experience = ({ experience }) => {
  if (!experience?.length) return null;

  return (
    <section id="journey" className="py-24 md:py-32 border-t border-white/10" data-testid="journey-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-4">CHAPTERS 01 — 07 · 2009 → TODAY</p>
        <h2 className="font-display text-3xl md:text-4xl text-gray-100 mb-20">
          The journey, <span className="italic text-emerald-400">chapter by chapter.</span>
        </h2>

        <div className="relative">
          <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-white/10" />

          <div className="space-y-20">
            {experience.map((exp, i) => (
              <motion.article
                key={exp.id}
                className="relative pl-10 md:pl-16"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true, margin: "-80px" }}
                data-testid={`journey-chapter-${exp.chapter}`}
              >
                <span className="absolute left-0 top-1.5 h-[15px] w-[15px] md:h-[19px] md:w-[19px] border border-emerald-500 bg-[#050505]">
                  <span className="absolute inset-[4px] bg-emerald-500" />
                </span>

                <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-3">
                  [ CH.{exp.chapter} ] — {exp.duration}
                </p>
                <h3 className="font-display text-2xl md:text-3xl text-gray-100 mb-1">{exp.chapterTitle}</h3>
                <p className="font-mono text-sm text-gray-400 mb-1">
                  {exp.position} · <span className="text-gray-100">{exp.company}</span>
                </p>
                <p className="font-mono text-xs text-gray-600 mb-6 inline-flex items-center gap-1">
                  <MapPin className="h-3 w-3" /> {exp.location}
                </p>

                <p className="font-display italic text-lg text-gray-300 leading-relaxed max-w-3xl mb-6">
                  {exp.narrative}
                </p>

                <ul className="space-y-2 max-w-3xl">
                  {exp.responsibilities.map((r, idx) => (
                    <li key={idx} className="text-sm text-gray-500 leading-relaxed flex gap-3">
                      <span className="text-emerald-500 mt-0.5 shrink-0">▸</span>
                      {r}
                    </li>
                  ))}
                </ul>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
